import { useCallback, useMemo } from "react";

import { proNavigator } from "single-spa/react-app/ProNavigator";

import { useAlertsParams } from "../../hooks/useAlertsParams";

import type { AlertTabId, TabItem } from "./config";

const getValidTab = (urlTab: AlertTabId | undefined, availableTabs: readonly TabItem[]): AlertTabId => {
    if (urlTab && availableTabs.some((t) => t.id === urlTab)) {
        return urlTab;
    }

    return availableTabs[0].id;
};

export const useTabFromUrl = (availableTabs: readonly TabItem[]) => {
    const { tab, alertsType } = useAlertsParams();

    const currentTab = useMemo(() => getValidTab(tab, availableTabs), [tab, availableTabs]);

    const tabIndex = useMemo(() => {
        const index = availableTabs.findIndex((t) => t.id === currentTab);
        return index >= 0 ? index : 0;
    }, [availableTabs, currentTab]);

    const setTab = useCallback(
        (tabId: AlertTabId) => {
            if (alertsType) {
                proNavigator.updateQueryParams({ tab: tabId, alertsType: undefined }, { reload: false });
            } else {
                proNavigator.updateQueryParams({ tab: tabId }, { reload: false });
            }
        },
        [alertsType],
    );

    const handleTabChange = useCallback(
        (index: number) => {
            if (availableTabs[index]) {
                setTab(availableTabs[index].id);
            }
        },
        [availableTabs, setTab],
    );

    return { currentTab, tabIndex, setTab, handleTabChange };
};
